module.exports = __webpack_public_path__ + "static/media/iconTextbook.34a90150.svg";